export const jade = {
  1: { value: { base: '{colors.jade.light.1}', _dark: '{colors.jade.dark.1}' } },
  2: { value: { base: '{colors.jade.light.2}', _dark: '{colors.jade.dark.2}' } },
  3: { value: { base: '{colors.jade.light.3}', _dark: '{colors.jade.dark.3}' } },
  4: { value: { base: '{colors.jade.light.4}', _dark: '{colors.jade.dark.4}' } },
  5: { value: { base: '{colors.jade.light.5}', _dark: '{colors.jade.dark.5}' } },
  6: { value: { base: '{colors.jade.light.6}', _dark: '{colors.jade.dark.6}' } },
  7: { value: { base: '{colors.jade.light.7}', _dark: '{colors.jade.dark.7}' } },
  8: { value: { base: '{colors.jade.light.8}', _dark: '{colors.jade.dark.8}' } },
  9: { value: { base: '{colors.jade.light.9}', _dark: '{colors.jade.dark.9}' } },
  10: { value: { base: '{colors.jade.light.10}', _dark: '{colors.jade.dark.10}' } },
  11: { value: { base: '{colors.jade.light.11}', _dark: '{colors.jade.dark.11}' } },
  12: { value: { base: '{colors.jade.light.12}', _dark: '{colors.jade.dark.12}' } },
  a1: { value: { base: '{colors.jade.light.a1}', _dark: '{colors.jade.dark.a1}' } },
  a2: { value: { base: '{colors.jade.light.a2}', _dark: '{colors.jade.dark.a2}' } },
  a3: { value: { base: '{colors.jade.light.a3}', _dark: '{colors.jade.dark.a3}' } },
  a4: { value: { base: '{colors.jade.light.a4}', _dark: '{colors.jade.dark.a4}' } },
  a5: { value: { base: '{colors.jade.light.a5}', _dark: '{colors.jade.dark.a5}' } },
  a6: { value: { base: '{colors.jade.light.a6}', _dark: '{colors.jade.dark.a6}' } },
  a7: { value: { base: '{colors.jade.light.a7}', _dark: '{colors.jade.dark.a7}' } },
  a8: { value: { base: '{colors.jade.light.a8}', _dark: '{colors.jade.dark.a8}' } },
  a9: { value: { base: '{colors.jade.light.a9}', _dark: '{colors.jade.dark.a9}' } },
  a10: { value: { base: '{colors.jade.light.a10}', _dark: '{colors.jade.dark.a10}' } },
  a11: { value: { base: '{colors.jade.light.a11}', _dark: '{colors.jade.dark.a11}' } },
  a12: { value: { base: '{colors.jade.light.a12}', _dark: '{colors.jade.dark.a12}' } },
}
